export default "__VITE_ASSET__DGdQDO_2__"